import currentEditorStore     from '@/TokamapEditor/stores/currentEditorStore';
import leftSidebarStore       from '@/TokamapEditor/stores/leftSidebarStore';
import { FormModal }          from '@widesk-ui/components/modal/FormModal';
import FileForm               from '@/forms/FileForm';
import { isBlockedByLimit }   from '@/components/Functionality/functionalityGuards';
import { functionalityStore } from '@/components/Functionality';
import preventConcurrentCalls from '@/tools/preventConcurrentCalls';

/**
 * Ouvre la modal d'import d'image puis démarre le dessin (`editor.startDrawingImage`) au succès —
 * même flux qu'avant sur le bouton "Importer une image" de l'ancien panneau "Images de fond"
 * (`ImageListSidebar`, supprimé), désormais partagé entre l'entrée "Image" de `ShapesButton` et le
 * raccourci clavier "I" (`useKeyboardShortcuts`).
 */
async function checkAndOpenImportImageModal() {
	const editor = currentEditorStore.get;
	const mapUrn = currentEditorStore.map?.urn;

	if (await isBlockedByLimit({ reference: 'nb_images' })) return;

	leftSidebarStore.close();

	return FormModal.open({
		children: (
			<FileForm
				forceSvgToHaveWidthAndHeight
				typeReference="map_image"
				sourceUrn={mapUrn}
				hideDescription
				hideType
				required
				submitOnChange
				onSuccessFiles={(files, rawFiles) => {
					functionalityStore.refreshUsagesOf('nb_images');

					const src = files[0]?.downloadPath;
					// Voir `replaceFeatureImage.tsx` : `downloadPath` n'a pas d'extension `.svg`,
					// on précise donc le format explicitement à partir du mime type natif.
					const svg = rawFiles[0]?.type === 'image/svg+xml';
					if (src) return editor.startDrawingImage(src, { svg });
				}}
			/>
		),
		title: `Importer une image`,
	});
}

const openImportImageModal = preventConcurrentCalls(checkAndOpenImportImageModal);

export default openImportImageModal;
